
define('text!Amasty_GdprFrontendUi/template/components/elems.html',[],function () { return '<!-- ko foreach: elems() -->\n    <!-- ko template: getTemplate() --><!-- /ko -->\n<!-- /ko -->\n';});

